import React, { useCallback, useEffect, useState } from "react"
import { MediaProductType, SocialAccountData } from "../../types/influencer/influencerTypes";
import InfluencerPostCard from "./InfluencerPostCard";
import Skeleton from "react-loading-skeleton";
import InfiniteScroll from "react-infinite-scroll-component";
import { useMediaQuery } from "react-responsive";
import { isDesktopMediaQuery } from "../../constants/constants";
import { useDispatch } from "react-redux";
import { setSelectedPost, setSelectedSocialPost } from "../../redux-stores/slices/layoutSlice";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux-stores/store";
import { fetchInfluencerContent, fetchSocialPostsThunk } from "../../redux-stores/slices/influencerContentSlice";
import SocialPostCard from "./SocialPostCard";


// enum SortOptionsWithLabels {
//     timestamp = "Most Recent",
//     like_count = "Most Liked",
//     comments_count = "Most Commented",
//     reach_count = "Most Reached",
//     shares_count = "Most Shared"
// }

const InfluencerSocialContent: React.FC<{socialAccount: SocialAccountData}> = ({socialAccount}) => {
    // const [sortBy, setSortBy] = useState<SortOption>(SortOption.TIMESTAMP);
    // const [page, setPage] = useState<number>(1);
    // const [hasMore, setHasMore] = useState<boolean>(true);
    // const [posts, setPosts] = useState<Post[]>([]);
    // const [loading, setLoading] = useState<boolean>(false);
    const platform = socialAccount?.social_account.platform;
    const [mediaProductType, setMediaProductType] = useState<MediaProductType | null>(null);

    useEffect(() => {
        if (platform === 'ig') {
            setMediaProductType(MediaProductType.REEL);
        } else if (platform === 'yt') {
            setMediaProductType(MediaProductType.VIDEO);
        }
    }, [platform])


    const data = useSelector(
        (state: RootState) => state.influencerContent.social_posts?.[socialAccount?.social_account.uuid!]?.[mediaProductType!]
    );


    const posts = data ? data.items : [];
    const page = data ? data.page : 1;
    const has_more = data ? data.has_more : true;

    const loading = useSelector((state: RootState) => state.influencerContent.loading);

    const isDesktop = useMediaQuery(isDesktopMediaQuery)

    const dispatch: AppDispatch = useDispatch();

    const fetchContent = useCallback(async (pageNumber: number) => {
        if (!socialAccount || !mediaProductType) return;
        dispatch(fetchSocialPostsThunk({ socialAccountId: socialAccount.social_account.uuid, mediaProductType: mediaProductType, page: pageNumber }))
    }, [dispatch, mediaProductType, socialAccount])

    useEffect(() => {
        fetchContent(1);
    }, [mediaProductType, fetchContent, socialAccount])

    const nextPage = () => {
        if (has_more && !loading) {
            const nextPageNumber = page + 1;
            fetchContent(nextPageNumber)
        }
    }

    return (
        <React.Fragment>
            <div className="card card-style m-0 rounded-card">
                <div className="card-body">
                    <div className="card-header p-0 border-0 bg-transparent">
                        <ul className="nav nav-tabs">
                            {
                                socialAccount?.social_account.platform === 'yt' &&
                                <li className="nav-item">
                                    <a href="#content-all" onClick={(e) => setMediaProductType(MediaProductType.VIDEO)} className={`nav-link ${mediaProductType === MediaProductType.VIDEO && 'active'}`}>All Videos</a>
                                </li>
                            }
                            {
                                socialAccount?.social_account.platform === 'ig' &&
                                <>
                                    <li className="nav-item">
                                        <a href="#content-reels" onClick={(e) => setMediaProductType(MediaProductType.REEL)} className={`nav-link ${mediaProductType === MediaProductType.REEL && 'active'}`}>Reels</a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#content-posts" onClick={(e) => setMediaProductType(MediaProductType.FEED)} className={`nav-link ${mediaProductType === MediaProductType.FEED && 'active'}`}>Posts</a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#content-stories" onClick={(e) => setMediaProductType(MediaProductType.STORY)} className={`nav-link ${mediaProductType === MediaProductType.STORY && 'active'}`}>Stories</a>
                                    </li>
                                </>
                            }
                        </ul>
                        {/* <div className="card-toolbar">
                            <div className="form-group mt-2">
                                <label htmlFor="sort-by">Sort By <i className="fa-solid fa-arrow-down-wide-short"></i></label>
                                <select id="sort-by" value={sortBy} onChange={(e) => setSortBy(e.target.value as SortOption)} className="form-select font-14">
                                    {Object.entries(SortOptionsWithLabels).map(([value, label], i) => (
                                        <option key={i} value={value}>{label}</option>
                                    ))}
                                </select>
                            </div>
                        </div> */}
                    </div>
                    <div className="card-body p-0 mt-2">
                        <InfiniteScroll
                            className="row m-0"
                            hasMore={has_more}
                            next={nextPage}
                            dataLength={has_more ? posts.length + 1 : posts.length}
                            loader={<></>}

                        >
                            {posts.map((post, postIndex) => (
                                <div className="col-6 p-1" key={postIndex} style={{ position: 'relative' }}>
                                    <SocialPostCard post={post} onPostClick={postId => dispatch(setSelectedSocialPost({ socialPostId: postId, socialAccountId: socialAccount?.social_account.uuid! }))} />
                                </div>
                            ))}
                            {
                                loading && Array.from({ length: (posts.length % 2) ? 4 : 3 }).map((_, i) => {
                                    return (
                                        <div className="col-6 p-1" key={i}>
                                            <Skeleton style={{ width: '100%', height: isDesktop ? '270px' : '145px', borderRadius: '10px', padding: 0, margin: 0 }} />
                                        </div>
                                    )
                                })
                            }
                        </InfiniteScroll>
                        {
                            !loading && !posts.length &&
                            <span className="w-100 d-flex justify-content-center p-5">No content yet!</span>
                        }
                    </div>

                </div>
            </div>
        </React.Fragment>

    );
};

export default InfluencerSocialContent;